(() => {
  function initialize(root) {
    if (root.dataset.wkReady) return;
    root.dataset.wkReady = 'true';
    const form = root.querySelector('.wk-form');
    if (!form) return;
    const offers = form.querySelector('[data-wk-bundles]');
    const subscription = form.querySelector('[data-wk-subscription]');
    const plan = form.querySelector('[name="selling_plan"]');
    const quantity = form.querySelector('[data-wk-quantity]');
    const total = form.querySelector('[data-wk-total]');
    const note = form.querySelector('[data-wk-offer-note]');
    function update() {
      const recurring = form.querySelector('[name="wk_mode"]:checked')?.value === 'subscribe';
      offers.hidden = recurring;
      note.hidden = recurring;
      if (subscription) subscription.hidden = !recurring;
      if (plan) plan.disabled = !recurring;
      const offer = form.querySelector('[name="wk_bundle"]:checked');
      quantity.value = recurring ? '1' : (offer?.value || '1');
      total.textContent = recurring && plan ? plan.selectedOptions[0].dataset.total : offer.dataset.total;
    }
    form.addEventListener('change', update);
    let submitting = false;
    const submit = async event => {
      event.preventDefault();
      update();
      const button = form.querySelector('button[type="submit"]');
      if (submitting) return;
      submitting = true;
      const error = form.querySelector('[data-wk-error]');
      error.hidden = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(form.action + '.js', {method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || root.dataset.addError);
        window.location.assign(root.dataset.cartUrl);
      } catch (failure) {
        error.textContent = failure.message || root.dataset.addError;
        error.hidden = false;
        submitting = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    };
    form.addEventListener('submit', submit);
    form.querySelector('button[type="submit"]').addEventListener('click', submit);
    update();

    const reviewSection = root.querySelector('#KidsReviews');
    const reviewTemplate = reviewSection?.querySelector('[data-wk-review-template]');
    let loadingReviews = false;
    async function loadReviews() {
      if (loadingReviews || !reviewTemplate) return;
      loadingReviews = true;
      const placeholder = reviewSection.querySelector('[data-wk-review-placeholder]');
      try {
        const loader = [...document.scripts].find(script => script.src.includes('/judgeme-') && script.src.includes('/loader.js'));
        if (!loader) throw new Error(root.dataset.reviewsError);
        const base = new URL('.', loader.src).href;
        const content = reviewTemplate.content.cloneNode(true);
        const widget = content.querySelector('[data-entry-key]');
        const response = await fetch(base + 'manifest.json');
        if (!response.ok) throw new Error(root.dataset.reviewsError);
        const manifest = await response.json();
        const styles = new Set();
        const visited = new Set();
        function collect(key) {
          if (visited.has(key)) return;
          visited.add(key);
          const entry = manifest[key];
          if (!entry) return;
          (entry.css || []).forEach(path => styles.add(new URL(path, base).href));
          (entry.imports || []).forEach(collect);
        }
        collect(widget.dataset.entryKey);
        await Promise.all([...styles].map(href => new Promise((resolve, reject) => {
          if ([...document.querySelectorAll('link[rel="stylesheet"]')].some(link => link.href === href)) return resolve();
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = href;
          link.onload = resolve;
          link.onerror = reject;
          document.head.append(link);
        })));
        const entryPoint = widget.dataset.entryPoint;
        reviewSection.append(content);
        const script = document.createElement('script');
        script.type = 'module';
        script.src = new URL(entryPoint, base).href;
        script.onload = () => { if (placeholder) placeholder.hidden = true; };
        script.onerror = () => { if (placeholder) placeholder.querySelector('[role="status"]').textContent = root.dataset.reviewsError; };
        document.head.append(script);
      } catch {
        if (placeholder) placeholder.querySelector('[role="status"]').textContent = root.dataset.reviewsError;
      }
    }
    if (reviewSection && reviewTemplate) {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            observer.disconnect();
            loadReviews();
          }
        }, {rootMargin: '500px'});
        observer.observe(reviewSection);
      } else loadReviews();
      root.querySelector('a[href="#KidsReviews"]')?.addEventListener('click', loadReviews);
    }
  }
  function init() { document.querySelectorAll('[data-wk-page]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

